var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuote(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#quote_svg__clip0)",
    fill: "#A3B7D9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.088 15.92c0-4.25.998-7.625 2.994-10.125C5.08 3.295 8.072 1.67 11.941.92v4.5c-2.87.875-4.866 2.5-5.864 4.75-.5 1.124-.749 2.374-.624 3.624h6.737v11.25H.088V15.92zm16.469 0c0-4.376.998-7.75 3.12-10.125 2.12-2.5 4.99-4 8.858-4.875v4.5c-2.87.875-4.866 2.5-5.74 4.75-.623 1.25-.748 2.374-.623 3.5h6.737v11.25H16.807v-9h-.25z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "quote_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.088 .92)",
    d: "M0 0h28.571v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default "/_next/static/images/e0422784ee9bec674f596605ee224341.svg";
export { ForwardRef as ReactComponent };